module.exports = __webpack_public_path__ + "img/MEP.61f9cc45.png";